import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import Colors from "../../../themes/Colors";
import { useMountEffect } from "../../../hooks/LifeCycle";
import moment from "moment";
import { DATE_FORMATS, TIME_SCALE } from "../../../utils/Constant";
import useEmpresa from "../../../hooks/useEmpresa";
import { camposCompletos } from "../../../utils/ValidationUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import { MAXIMO_DIAS_CONSULTA_CIERRES } from "../utils/IngresoConstant";

const BusquedaCierresCuentasForm = (props) => {
  const { formConsultaCierresCuentasData, consultarCierresCuentasLoading } =
    props;

  const empresa = useEmpresa();
  const { prestador } = props?.authUserData;
  const pagina = 1;
  const tamanoPagina = 10;

  useMountEffect(() => {
    let startDate = moment(new Date())
      .subtract(MAXIMO_DIAS_CONSULTA_CIERRES, TIME_SCALE.dia)
      .format(DATE_FORMATS.middledash_ymd);

    let today = moment(new Date()).format(DATE_FORMATS.middledash_ymd);

    consultarUltimosCierres(startDate, today);
  });

  const onStateChange =
    (key, format = null) =>
    (value) => {
      props.formConsultaCierresCuentas({
        ...formConsultaCierresCuentasData,
        [key]: format ? format(value) : value,
      });
    };

  const consultarUltimosCierres = (fechaInicio, fechaFin) => {
    props.consultarCierresCuentas({
      formConsultaCierresCuentasData: formConsultaCierresCuentasData,
      formHandler: props.formConsultaCierresCuentas,
      compania: empresa?.CODIGO,
      reclamante: prestador?.codigo,
      fechaInicio,
      fechaFin,
      pagina: pagina,
      tamanoPagina: tamanoPagina,
    });
  };

  const buscarCierresCuentas = () => {
    const {
      fechaInicio,
      fechaFin,
      numeroReclamacion,
      numeroAfiliado,
      fechaServicio,
      fechaSalida,
    } = formConsultaCierresCuentasData;

    let mensajeValidacion = null;

    if (!camposCompletos({ fechaInicio, fechaFin })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    } else if (          moment(fechaInicio)
      .startOf("day")
      .isAfter(moment(fechaFin).startOf("day"))) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    const rangoDias = moment(fechaFin).diff(moment(fechaInicio), "days");

    if (rangoDias > MAXIMO_DIAS_CONSULTA_CIERRES) {
      mensajeValidacion = `El rango de fechas debe ser menor de ${MAXIMO_DIAS_CONSULTA_CIERRES} días.`;
    }

    if (mensajeValidacion) {
      props.formConsultaCierresCuentas({
        ...formConsultaCierresCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: mensajeValidacion,
          onConfirm: () => {
            props.formConsultaCierresCuentas({
              ...formConsultaCierresCuentasData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      });
      return;
    }

    props.consultarCierresCuentas({
      formConsultaCierresCuentasData: formConsultaCierresCuentasData,
      formHandler: props.formConsultaCierresCuentas,
      compania: empresa?.CODIGO,
      reclamante: prestador?.codigo,
      fechaInicio,
      fechaFin,
      numeroReclamacion,
      numeroAfiliado,
      fechaServicio,
      fechaSalida,
      pagina: pagina,
      tamanoPagina: tamanoPagina,
    });
  };

  return (
    <FormWrapper borderColor={Colors.transparent}>
      <Form justifyContent={"space-between"}>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={`No. Reclamación`}
            label={"No. Reclamación"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formConsultaCierresCuentasData?.numeroReclamacion}
            onChange={onStateChange("numeroReclamacion")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            maxDate={formConsultaCierresCuentasData?.fechaFin}
            required={true}
            placeholder={"Fecha Desde"}
            label={"Desde"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formConsultaCierresCuentasData?.fechaInicio}
            onChange={onStateChange("fechaInicio")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            minDate={formConsultaCierresCuentasData?.fechaInicio}
            required={true}
            placeholder={"Fecha Hasta"}
            label={"Hasta"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formConsultaCierresCuentasData?.fechaFin}
            onChange={onStateChange("fechaFin")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"No. de Carnet"}
            label={"No. de Carnet"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formConsultaCierresCuentasData?.numeroAfiliado}
            onChange={onStateChange("numeroAfiliado")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            required={false}
            placeholder={"Fecha Servicio"}
            label={"Fecha Servicio"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formConsultaCierresCuentasData?.fechaServicio}
            onChange={onStateChange("fechaServicio")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            required={false}
            placeholder={"Fecha Salida"}
            label={"Fecha Salida"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formConsultaCierresCuentasData?.fechaSalida}
            onChange={onStateChange("fechaSalida")}
          />
        </FormGroup>
        <FormGroup>
          <CustomButton
            label={"Buscar"}
            onClick={buscarCierresCuentas}
            isLoading={consultarCierresCuentasLoading}
            height={"46px"}
            width={"100px"}
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formConsultaCierresCuentasData: state.ingreso.formConsultaCierresCuentasData,
  formConsultaCierresCuentasLoading:
    state.ingreso.formConsultaCierresCuentasLoading,

  consultarCierresCuentasLoading: state.ingreso.consultarCierresCuentasLoading,
});

const mapDispatchToProps = {
  formConsultaCierresCuentas: IngresoActions.formConsultaCierresCuentas,
  consultarCierresCuentas: IngresoActions.consultarCierresCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(BusquedaCierresCuentasForm);
